import Chocolat from "chocolat";

document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll(".wp-block-gallery.enable-lightbox");
  const lightboxes = [];
  let sources;

  // We loop through all galleries currently on the page.
  for (let i = 0; i < galleries.length; i++) {
    sources = []; // Setup the source array, which holds all images.
    const gallery = galleries[i];

    const galleryItems = gallery.querySelectorAll(".blocks-gallery-item");

    for (let j = 0; j < galleryItems.length; j++) {
      const item = galleryItems[j];
      const image = item.querySelector("figure > img");
      if (image.sizes && image.srcset) {
        const { sizes, srcset, src } = image;
        sources.push({
          src: extractPath(src),
          sizes: sizes,
          srcset: srcset,
          title: image.alt ? image.alt : "",
        });
      } else {
        sources.push({
          src: extractPath(image.src),
          title: image.alt ? image.alt : "",
        });
      }
    }

    lightboxes.push(new Chocolat(sources)); // We initialize a lightbox.

    const currentLightbox = lightboxes[i].api;

    for (let j = 0; j < galleryItems.length; j++) {
      const item = galleryItems[j];
      item.addEventListener("click", () => currentLightbox.open(j));
    }
  }
});

function extractPath(url) {
  try {
    return new URL(url).pathname;
  } catch (e) {
    return url;
  }
}
